<div class="article-list-image" *ngIf="carrousel">
  <swiper [config]="config" [ngStyle]="{ 'height': maxHeight + 'px' }">
    <ng-template swiperSlide  *ngFor="let image of carrousel">
      <img src="{{image.image_url}}"/>
      <div class="image-caption-wrapper">
        <div class="image-description" *ngIf="image?.image_description"><span [innerHTML] = "image?.image_description"></span></div>
        <div class="copyright-carrousel" *ngIf="image?.image_copyright">&copy; {{image.image_copyright}}</div>
      </div>
    </ng-template>
  </swiper>
</div>
